import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideEdsTheme, provideMaterialConfig } from '@eventim/eds2/styling-angular';
import { provideEdsIconRegistry } from '@eventim/eds2/svg-kit';

import { routes } from './app.routes';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideEdsTranslationProxyService } from '@eventim/eds2/i18n';
import { authInterceptor, provideAuth } from 'angular-auth-oidc-client';
import { authConfig } from './auth/auth.config';
import { CustomTranslationProxyService } from './core/i18n/custom-translation-proxy-service';
import { provideTranslateService, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { firstValueFrom } from 'rxjs';
import { ApiErrorInterceptor } from './core/error/api-error.interceptor';
import { apiUrlInterceptor } from './core/interceptors/api-url.interceptor';

const locale = localStorage.getItem('locale') ?? 'fr-FR';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: ApiErrorInterceptor, multi: true },
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: 'i18n/',
        suffix: '.json',
      }),
      lang: locale,
    }),
    provideAppInitializer(() => {
      const translate = inject(TranslateService);
      return firstValueFrom(translate.use(locale));
    }),

    // Styling
    provideMaterialConfig(),
    provideAnimations(),

    // EDS
    provideEdsTheme(),
    provideEdsIconRegistry(),
    provideEdsTranslationProxyService({
      translationProxyService: CustomTranslationProxyService,
    }),

    // Auth
    provideHttpClient(withInterceptors([authInterceptor(), apiUrlInterceptor])),
    provideAuth(authConfig),
  ],
};
